import { useMap } from 'react-leaflet';
import { useEffect, useRef } from 'react';

function RecenterMapOnce({ position }) {
  const map = useMap();
  const hasCentered = useRef(false);

  useEffect(() => {
    if (position && !hasCentered.current) {
      map.setView(position, map.getZoom());
      hasCentered.current = true;
    }
  }, [position, map]);

  return null;
}


export default RecenterMapOnce;